import React from 'react'

// ชิ้นส่วนเล็กๆ ที่ใช้ซ้ำทั้งใบสมัครและใบมอบตัว
//
// ระบบเดิมเขียนพวกนี้ inline ซ้ำทุกที่ — เช่นช่องเลขบัตร 13 หลักถูก copy เป็น
// <span className="box-closed"> สิบสามอันเรียงกัน ปรากฏอยู่ 6 ที่ในสองไฟล์

// ช่องว่างแบบ em space (U+2003) ใช้ดันความยาวเส้นใต้เวลาไม่มีข้อมูล เหมือนของเดิม
// ต้องเป็น em space จริงๆ ไม่ใช่เว้นวรรคธรรมดา เพราะ HTML ยุบเว้นวรรคธรรมดาให้เหลือช่องเดียว
export const blank = (n) => ' '.repeat(n)

const EM = ' '

// ข้อความบนเส้นใต้ — โครงเดิมคือ <p className='underline'>&emsp;{value}&emsp;</p>
// ต้องคง <p> แบบ inline-block ไว้ เพราะการตัดบรรทัดของทั้งหน้าขึ้นกับพฤติกรรมนี้
export const L = ({ value, pad = 5, className = '' }) => (
  <p className={`underline ${className}`}>
    {EM}{value || blank(pad)}{EM}
  </p>
)

// ช่องสี่เหลี่ยมใส่ตัวเลขทีละหลัก
//
// gaps คือ index ที่ต้องเว้นวรรคหลังช่องนั้น — ค่าที่ส่งเข้ามาคัดลอกจากระบบเดิมตรงๆ
// (เลขบัตรเว้นหลังหลักที่ 0, 5, 9, 11 ซึ่งไม่ตรงกับรูปแบบมาตรฐาน 1-4-5-2-1 เป๊ะ
//  แต่คงไว้ให้เหมือนของเดิมตามที่ขอ)
export const Boxes = ({ chars, gaps = [], className = 'box-closed' }) => (
  <>
    {chars.map((c, i) => (
      <span key={i} className={`${className}${gaps.includes(i) ? ' me-2' : ''}`}>{c}</span>
    ))}
  </>
)

export const ID_CARD_GAPS = [0, 5, 9, 11]
export const HOME_ID_GAPS = [3, 9]

// ไอคอนช่องติ๊ก — ระบบเดิมใช้ bootstrap-icons ซึ่ง SIS ไม่ได้ติดตั้งไว้
// จึงใช้ remixicon ที่หน้าตาตรงกัน (วงกลมเปล่า / วงกลมมีเครื่องหมายถูก)
export const Mark = ({ on, className = '' }) => (
  <i className={`${on ? 'ri-checkbox-circle-line' : 'ri-checkbox-blank-circle-line'} ${className}`} />
)

export const Sq = ({ on, className = '' }) => (
  <i className={`${on ? 'ri-checkbox-line' : 'ri-checkbox-blank-line'} ${className}`} />
)

export const Star = ({ className = 'me-1' }) => <i className={`ri-asterisk ${className}`} />

export const Tel = ({ className = 'me-2' }) => <i className={`ri-phone-fill ${className}`} />

// บล็อกที่อยู่ — ของเดิมมีสองแบบ: มีข้อมูลครบก็พิมพ์ต่อกัน ไม่ครบก็โชว์เส้นเปล่า
// พร้อมช่อง "หมู่ที่ / ถนน" ที่ไม่มีในฐานข้อมูลให้เขียนมือ
export const AddressLine = ({ detail, subDistrict, district, province, label = 'ที่อยู่บ้านเลขที่' }) => {
  if (detail && subDistrict && district && province) {
    return (
      <>
        {label}<L value={detail} />
        ตำบล<L value={subDistrict} />
        อำเภอ<L value={district} />
        จังหวัด<L value={province} />
      </>
    )
  }
  return (
    <>
      {label}<p className="underline">{blank(3)}</p>
      หมู่ที่<p className="underline">{blank(2)}</p>
      ถนน<p className="underline">{blank(6)}</p>
      ตำบล<L value={subDistrict} pad={4} />
      อำเภอ<L value={district} pad={4} />
      จังหวัด<L value={province} pad={4} />
    </>
  )
}
